import React from "react";

const ArrowRightLine = ({style = {}, size = "36", className = "", fill = "#73788B", viewBox = "0 0 36 36"}) => (
    <svg
        width={size}
        style={style}
        height={size}
        viewBox={viewBox}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={`${className || ""}`}
        xmlnsXlink="http://www.w3.org/1999/xlink"
    >
        <path
            fill={fill}
            className="u_fill"
            d="M26.122 16H1.778v4h24.344L15.394 30.727l2.828 2.828L33.778 18 18.222 2.444l-2.828 2.828L26.122 16Z"
        />
    </svg>
);

export default ArrowRightLine;
